export const SET_WALLET = "SET_WALLET";
export const SET_WALLET_BALANCE = "SET_WALLET_BALANCE";
